import { useState } from "react";
import '../style/products/saas.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import logo from '../img/quanto_light.png';

export default function QuantoSaas() {
  const [activeMainTab, setActiveMainTab] = useState("operation");
  const [fade, setFade] = useState(false);

  const mainTabContent = {
    operation: {
      title: "How Quanto SaaS Operates?",
      subTabs: {
        cloud: "The software is hosted on cloud servers, and users access it via the internet using a web browser or app.",
        subscription: "Clients pay a recurring fee (monthly or annually) to use the module, without needing to buy the software license.",
        updates: "Quanto manages software updates and security patches, ensuring users always have the latest version.",
        scalability: "Easily scale up or down by adding/removing features or users as business needs change.",
        security: "Quanto handles data storage and security, often with built-in encryption and backup.",
        multiDevice: "The module can be accessed from various devices like computers, tablets, or smartphones.",
        migration: "Quanto will transfer your current live stock and barcode data to the Quanto SaaS platform.",
        installation: "Quanto will offer online training and assist with configuration setup."
      }
    },
    benefits: {
      title: "Benefits of Quanto SaaS",
      subTabs: {
        costEffective: "No huge upfront investments & hardware costs; pay-as-you-go model.",
        scalable: "Easily adjust features and users as needed.",
        accessible: "Use from any device with internet access.",
        autoUpdates: "Always have the latest software and security patches with backups every 5 minutes.",
        dataSecurity: "Quanto ensures secure data storage with protection against data loss from virus attacks.",
        quickSetup: "Fast deployment with no complex installation of servers or networking required."
      }
    }
  };
  

  const handleMainTabChange = (key) => {
    setFade(true);
    setTimeout(() => {
      setActiveMainTab(key);
      setFade(false);
    }, 300); // Adjust this duration to match the CSS animation
  };

  const navigateToPricing = () => {
    window.location.href = '/pricing';
  };

  return (
    <>
      <Header />
      <section className="about-title-section">
        <h2><img alt="quantologo" src={logo} style={{ width: 280, marginLeft: 10, verticalAlign: "middle", marginBottom: 20 }} /> SAAS</h2>
      </section>
      <div className="saas-page">
        <div className="content-container-saas">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button className="brochure-btn">Download Brochure</button>
          </div>
          <h2 className="title-saas">Quanto SaaS</h2>
          <p className="subtitle-saas">
            Quanto SaaS (Software as a Service) is an only cloud-based tool that helps businesses manage and automate tasks easily over the internet. It’s flexible, cost-effective, and accessible from anywhere, with no need for complex IT setups. With automatic updates and secure data, it simplifies business operations while helping them grow efficiently.
          </p>
          <h1 className="main-title">
            Elevate Your Retail Business with Quanto SaaS - Simplify, Automate, and Grow!
          </h1>

          <div className="main-tabs">
            {Object.entries(mainTabContent).map(([key, value]) => (
              <button
                key={key}
                className={`main-tab-trigger ${activeMainTab === key ? "active" : ""}`}
                onClick={() => handleMainTabChange(key)}
                style={{
                  fontWeight: "bold", // Apply bold for all buttons
                }}
              >
                {value.title}
              </button>
            ))}
          </div>


          <div className={`grid-container-saas ${activeMainTab} ${fade ? 'fade-out' : 'fade-in'}`}>
            {Object.entries(mainTabContent[activeMainTab].subTabs).map(([key, value]) => (
              <div key={key} className="grid-item-saas">
                <h4>{formatTabTitle(key)}</h4>
                <p>{value}</p>
              </div>
            ))}
          </div>

          <div className="cta-section">
            <p className="cta-text">Book Quanto SaaS Now at Just Rs 1750* Per Month Per User</p>
            <button className="cta-button" onClick={navigateToPricing}>Learn More and Get Started</button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

// Helper function to format the tab title
const formatTabTitle = (key) => {
    const mappings = {
      cloud: "Cloud-Based Access",
      subscription: "Subscription Model",
      updates: "Automatic Updates",
      scalability: "Scalability",
      security: "Data Security",
      multiDevice: "Multi-Device Access",
      migration: "Migration",
      installation: "Installation & Training",
      costEffective: "Cost-Effective",
      scalable: "Scalable",
      accessible: "Accessible",
      autoUpdates: "Automatic Updates & Backups",
      dataSecurity: "Data Security",
      quickSetup: "Quick Setup"
    };
    return mappings[key] || key.charAt(0).toUpperCase() + key.slice(1);
  };
  